import SharePromptButton from '@/features/ai-chat/components/AskGXDrawer/SharePromptButton/SharePromptButton';
import TextType from '@/features/ai-chat/components/AskGXDrawer/TextType/TextType';

import { useHumanMessage } from './useHumanMessage';

import type { UIMessage } from '@tanstack/ai-client';

const HumanMessage = ({ msg }: { msg: UIMessage }) => {
  const { promptShareEnabled, animatedText, onAnimatedComplete, shouldAnimate } =
    useHumanMessage(msg);
  const text = msg.parts?.find(part => part.type === 'text')?.content ?? '';

  return (
    <div className='flex flex-col items-end self-end'>
      <div className='flex min-w-52 flex-col gap-3 rounded-xl border border-gx-border/70 bg-gx-response/70 px-4 py-3.5 shadow-sm'>
        <div className='wrap-break-word hyphens-auto text-sm leading-6 text-gx-text'>
          <div className='mb-1 text-xs font-semibold tracking-wide text-gx-subtext'>You</div>
          <div className='whitespace-pre-wrap'>
            {shouldAnimate ? (
              <TextType
                showCursor
                as='div'
                loop={false}
                text={animatedText ?? ''}
                onComplete={onAnimatedComplete}
              />
            ) : (
              text
            )}
          </div>
        </div>
        {promptShareEnabled && <SharePromptButton prompt={text} />}
      </div>
    </div>
  );
};

export default HumanMessage;
